import InsurancesTable from './InsurancesTable'
export default InsurancesTable
